

import Glide from "@glidejs/glide";
import { DropdownHeader } from "./functionalities/DropdownHeader";
import { CustomSelect } from "./functionalities/customSelect";




/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/App');

let nav = document.querySelector('.nav');
if(nav) {

    new DropdownHeader('.nav', '.containerCollapse');
}

var sliderPlanes = document.querySelector(".sliderPlanes");
if (sliderPlanes) {
 
        new Glide(sliderPlanes, {
            gap: 0,
            animationDuration: 300,
            perView: 3,
            bound: true,
            breakpoints: {
                600: {
                    perView: 1
                },
                900: {
                    perView: 2
                },
                992: {
                    perView: 3
                }
            }
        }).mount();
  
};

new CustomSelect();

